<template>
<div class="pt-3">

<TabView @tab-change="tabChange">
    <TabPanel >
        <template #header>
            <div class="flex align-items-center gap-2">                
                <span class="font-bold white-space-nowrap">{{$store.state.languages.lang_phrases.firma_belgeleri}}</span>
                <Badge v-if="awaiting_docs" severity="info" :value="awaiting_docs.toString()" />
            </div>
        </template>
        <OtherDocuments ref="otherdocuments" @awaitingDocsCounted="uploadedDocsCounted"/>
    </TabPanel>

    <TabPanel >
         <template #header>
            <div class="flex align-items-center gap-2">                
                <span class="font-bold white-space-nowrap">{{$store.state.languages.lang_phrases.muafiyet_sertifikalari}}</span>
                <Badge v-if="awaiting_required_docs" severity="info" :value="awaiting_required_docs.toString()" />
            </div>
        </template>
        <RequiredDocuments ref="requireddocuments" @awaitingDocsCounted="requiredDocsCounted"/>
    </TabPanel>
</TabView>

</div>
</template>

<script>
import moment from "moment";
import OtherDocuments from "./OtherDocuments"
import RequiredDocuments from "./RequiredDocuments"
export default {

  name: 'AuditDocuments',
  components:{OtherDocuments,RequiredDocuments},

  data () {
    return {
    	awaiting_docs:0,
        awaiting_required_docs:0,
    }
  },
  mounted()
  {
    //this.getOtherDocs()
  },
  methods:{
    uploadedDocsCounted(count)
    {
        this.awaiting_docs = count
    },
    requiredDocsCounted(count)
    {
        this.awaiting_required_docs = count
    },

    tabChange(data)
    {
        console.log(data)
        if(data.index ===0)
        {
            this.getOtherDocs()
        }
        if(data.index===1)
        {
            this.getReqDocs()
        }
    },
    getOtherDocs()
    {
        this.$refs.otherdocuments.getData()
    },
    getReqDocs()
    {
        this.$refs.requireddocuments.getData()
    },
  }
    
}
</script>

<style lang="css" scoped>
</style>